import { toast } from 'react-toastify';
import { LecturerPaymentRateListItem } from '../../../../../api/types/lecturers/price-rate/lecturer-payment-rate-list-item';
import { LecturerRateDisplayType } from '../../../../../api/types/lecturers/price-rate/lecturer-rate-display-type';
import { RequestRateStatus } from '../../../../../api/types/lecturers/price-rate/request-rate/request-rate-status';
import { getPaymentTypeDisplayText } from '../../../../../api/types/settings/lecturers/settings-lecturers-rate-type';
import generateAndDownloadExcelFile from '../../../../../component/excel/generate-and-download-excel-file';
import { formatDate } from '../../../../../utils/date-format';
import { LegalEntityType } from '../../../../user-page/roles/lecturer-price-rate/componenets/acountant/user-page-lecturer-rate-accountant';

const HEADERS = [
  'מרצה',
  'ת.ז.',
  'שלוחה',
  'פעילות',
  'תעריף',
  'תעריף נסיעות',
  'סוג תצוגה',
  'תוקף מ-',
  'תוקף עד',
  'סטטוס',
  'סוג תשלום',
  'תיאור בקשה',
  'סוג ישות',
  'קוד דיווח',
  'מזהה ישות',
  'קוד דיווח נסיעות',
  'חוזה',
  'חוזה חתום',
  'נוצר ב-',
  'נוצר ע״י',
  'סטטוס עודכן ב-',
  'סטטוס עודכן ע״י',
] as const;

const displayTypeLabel = (displayType: LecturerRateDisplayType): string => {
  switch (displayType) {
    case LecturerRateDisplayType.OneHour:
      return 'שעה שלמה';
    case LecturerRateDisplayType.AcademicHour:
      return 'שעה אקדמית';
    default:
      return displayType;
  }
};

const requestStatusLabel = (status: RequestRateStatus): string => {
  switch (status) {
    case RequestRateStatus.Approved:
      return 'מאושר';
    case RequestRateStatus.Pending:
      return 'ממתין';
    case RequestRateStatus.Denied:
      return 'נדחה';
    default:
      return status;
  }
};

const formatNullableDate = (
  value: Date | string | null | undefined,
): string => {
  if (value == null) return '';
  return formatDate(new Date(value));
};

const formatMoney = (value: number | null | undefined): string | number => {
  if (value == null) return '';
  return value;
};

/**
 * Exports the currently loaded rates-report rows as a single Excel sheet.
 * Columns mirror the full rates table column set.
 */
export const exportRatesReportToExcelOperation = (
  rows: LecturerPaymentRateListItem[],
  setExporting: (exporting: boolean) => void,
) => {
  try {
    if (!rows || rows.length === 0) {
      toast.warn('אין נתונים לייצוא');
      return;
    }

    setExporting(true);

    const dataRows = rows.map((row) => [
      `${row.firstName} ${row.lastName}`.trim(),
      row.nationalId ?? '',
      row.branchName ?? '',
      row.activityName ?? '',
      formatMoney(row.rate),
      formatMoney(row.travelRate),
      displayTypeLabel(row.displayType),
      formatNullableDate(row.startTime),
      formatNullableDate(row.endTime),
      requestStatusLabel(row.requestStatus),
      getPaymentTypeDisplayText(row.paymentType) ?? '',
      row.requestDescription ?? '',
      row.legalEntityType
        ? LegalEntityType.getDisplayText(row.legalEntityType)
        : '',
      row.reportingCode ?? '',
      row.legalEntityId ?? '',
      row.accountingReportCodeTravel ?? '',
      row.contractDoc?.docName ?? row.contractFileUrl ?? '',
      row.signedContractDoc?.docName ?? row.signedContractFileUrl ?? '',
      formatNullableDate(row.createdAt),
      row.createdByName ?? '',
      formatNullableDate(row.statusChangedAt),
      row.statusChangedName ?? '',
    ]);

    const today = new Date();
    const datePart = `${String(today.getDate()).padStart(2, '0')}-${String(
      today.getMonth() + 1,
    ).padStart(2, '0')}-${today.getFullYear()}`;

    generateAndDownloadExcelFile([[...HEADERS], ...dataRows], {
      fileName: `תעריפי הוראה (${rows.length}) - ${datePart}`,
      sheetName: 'תעריפי הוראה',
    });

    toast.success('הדוח יוצא לאקסל בהצלחה');
    setExporting(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setExporting(false);
  }
};
